import { render, staticRenderFns } from "./UsiMappingPage.vue?vue&type=template&id=3cdc1b96&"
import script from "./UsiMappingPage.vue?vue&type=script&lang=ts&"
export * from "./UsiMappingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports